import styled, { css } from "styled-components";
import tw from "twin.macro";

import { CollapseExpandSingleIcon, CloseSmallIcon } from "../Icons/collection";
import { Input } from "../Input/Input";
import { StyledInputWrapper } from "../Input/Styles";

export const StyledComboBoxInput = styled(Input)<{ $loading?: boolean }>`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;

StyledComboBoxInput.displayName = "StyledComboBoxInput";

const StyledIconDefaults = css`
  flex-shrink: 0;
  cursor: pointer;
`;

export const StyledComboBoxCollapseExpandSingleIcon = styled(
  CollapseExpandSingleIcon
)<{ $open?: boolean }>`
  ${StyledIconDefaults};
  color: var(--color-theme-600);
  transform: rotate(180deg);

  ${(props) =>
    props.$open &&
    css`
      transform: rotate(0deg);
    `}
`;

StyledComboBoxCollapseExpandSingleIcon.displayName =
  "StyledComboBoxCollapseExpandSingleIcon";

export const StyledComboBoxCloseSmallIcon = styled(CloseSmallIcon)`
  ${StyledIconDefaults};
  opacity: 0;
  transition-property: all;
  transition-duration: 0.2s;
  transition-delay: 0.5s;

  ${StyledComboBoxInput}:hover, ${StyledInputWrapper}:hover & {
    opacity: 1;
    transition-delay: 0s;
  }
`;

StyledComboBoxCloseSmallIcon.displayName = "StyledComboBoxCloseSmallIcon";

export const StyledComboBoxList = styled.div<{
  $width?: number;
  $hide: boolean;
}>`
  min-width: 260px;
  background-color: var(--page-paper-main);
  border-radius: 8px;
  border: 1px solid var(--border-primary);
  box-shadow: var(--shadow-tertiary);
  margin: 8px 0;
  width: ${(props) => `${props.$width}px`};

  ${({ $hide }) =>
    $hide === true &&
    css`
      display: none;
    `}
`;

StyledComboBoxList.displayName = "StyledComboBoxList";

export const StyledChipWrapper = styled.div<{
  $autoSize: string;
  $open?: boolean;
}>`
  ${tw`tw-flex`};
  ${tw`tw-gap-1`};
  ${tw`tw-flex-1`};

  ${({ $open }) =>
    !$open &&
    css`
      overflow: hidden;
    `}

  ${({ $autoSize }) =>
    $autoSize === "auto" &&
    css`
      ${tw`tw-flex-wrap`};
      ${tw`tw-w-full`};
    `}

  ${({ $autoSize }) =>
    $autoSize !== "auto" &&
    css`
      align-items: center;
    `}
`;
StyledChipWrapper.displayName = "StyledChipWrapper";
